import React from 'react';
interface ShinyTextProps {
  text: string;
  disabled?: boolean;
  speed?: number;
  className?: string;
}
/**
 * ShinyText (reactbits.dev inspired)
 * Animated metallic shimmer that sweeps across the text.
 * Pairs well with status pills and small accent labels.
 */
export function ShinyText({
  text,
  disabled = false,
  speed = 4,
  className = ''
}: ShinyTextProps) {
  return <span className={`shiny-text ${disabled ? 'shiny-text--disabled' : ''} ${className}`} style={{
    animationDuration: `${speed}s`
  }} data-id="element-50">
      {text}
    </span>;
}